import { Link } from 'react-router-dom';
import { Text, Title2, makeStyles } from '@fluentui/react-components';
import { tokens } from '@vigeo/ui';
import { ROSTER_PATH } from '@/lib/sections';

const useStyles = makeStyles({
  // No padding of its own: unlike "Page not found", this is drawn inside the shell, which already gives the page its margins.
  page: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalM },
  link: { alignSelf: 'flex-start', color: tokens.colorBrandForegroundLink },
});

/** Shown in place of any page whose section is switched off in this build (#610). The page itself is never loaded. */
export function SectionUnavailablePage() {
  const styles = useStyles();
  return (
    <div className={styles.page}>
      <Title2 as="h1">This section is not available yet</Title2>
      <Text>It is still being prepared. The Roster is ready to use.</Text>
      <Link to={ROSTER_PATH} className={styles.link}>
        <Text>Go to the Roster</Text>
      </Link>
    </div>
  );
}
